import BaseComponentController from "../base_component_controller"

export default class extends BaseComponentController {
  static targets = ['toggler', 'toggleable']

  static values = {
    disableToggleableInputs: Boolean,
    hideClasses: Array
  }

  toggle(event) {
    this.toggleableTargets.forEach(toggleable => {
      const show = event.currentTarget.type === 'checkbox' ? event.currentTarget.checked : toggleable.dataset.toggleableValue.split(',').indexOf(event.currentTarget.value) > -1

      this.hideClassesValue.forEach(hideClass => toggleable.classList.toggle(hideClass, !show))

      if (this.disableToggleableInputsValue) {
        toggleable.querySelectorAll('input, select, textarea').forEach(input => input.disabled = !show)
      }
    })
  }
}
